//import { ClientItem } from "@brushfire/types/dist/shared/DotNetModels";
export var SET_CLIENT = "SET_CLIENT";
